import { useMemo } from 'react'
import PropTypes from 'prop-types'

import { ReactComponent as TriangleIcon } from 'assets/icons/IconTriangle.svg'
import { ReactComponent as PencilIcon } from 'assets/icons/IconPencil.svg'
import PaginationButtons from 'components/Pagination/PaginationButtons'

const Pagination = ({
  selectedItemsBulkAction,
  selectedItemsBulkAmount,
  totalItemsCount,
  handleChangeRowsPerPage,
  handleClickPage,
  pageNumber,
  rowsPerPage,
}) => {
  const totalPageCount = useMemo(() => {
    return Math.ceil(totalItemsCount / rowsPerPage)
  }, [totalItemsCount, rowsPerPage])

  const showBulkOptions = selectedItemsBulkAmount > 0

  return (
    <>
      {showBulkOptions && (
        <div className="bulk">
          <span className="bulk__selected-items-amount">
            {selectedItemsBulkAmount}
          </span>
          <button
            className="bulk__selected-items-action"
            onClick={selectedItemsBulkAction}
          >
            Bulk Edit <PencilIcon />
          </button>
        </div>
      )}
      <div className="api-pagination__container">
        <div className="api-pagination__select-wrapper">
          <label htmlFor="offset" className="api-pagination__title">
            Rows per page:
          </label>
          <select
            className="api-pagination__select"
            name="offset"
            id="offset"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <TriangleIcon className="api-pagination__dropdown-icon" />
        </div>
      </div>
      <div className="api-pagination">
        <PaginationButtons
          totalPages={totalPageCount}
          currentPage={pageNumber}
          handleClickPage={handleClickPage}
          totalItemsCount={totalItemsCount}
        />
      </div>
    </>
  )
}

Pagination.defaultProps = {
  selectedItemsBulkAction: () => {},
  totalItemsCount: 0,
  handleChangeRowsPerPage: () => {},
  handleClickPage: () => {},
  pageNumber: 1,
  rowsPerPage: 25,
}

Pagination.propTypes = {
  selectedItemsBulkAction: PropTypes.func,
  selectedItemsBulkAmount: PropTypes.number,
  totalItemsCount: PropTypes.number,
  handleChangeRowsPerPage: PropTypes.func,
  handleClickPage: PropTypes.func,
  pageNumber: PropTypes.number,
  rowsPerPage: PropTypes.number,
}

export default Pagination
